(function () {

  'use strict';

  angular.module('eclipseApp.myAccount').directive('prepaidRefillPageHeader', ['$rootScope', 'uteLocale', 'prepaidAirtimeBalanceService', 'prepaidUserInfoService', function ($rootScope, uteLocale, prepaidAirtimeBalanceService, prepaidUserInfoService) {

    return {
      restrict: 'EA',
      scope: {
        stopAutoPaymentNotifier: '=notifier',
        backendNotifier: '=errorNotifier',
        hideWhatNeedSection: '=hideWhaddyaNeed'
      },
      templateUrl: 'modules/components/views/prepaid-refill-page-header.html',
      controller: ['$scope', function($scope){
        $scope.airtimeBalance = prepaidAirtimeBalanceService.getAirTimeBalance();
        $scope.expiryDate = prepaidAirtimeBalanceService.getExpiryDate();
        $scope.subscriberNumber = prepaidUserInfoService.getCTN();
        $scope.lang = uteLocale.language;
        //alert('hideWhatNeedSection :: '+$scope.hideWhatNeedSection);
      }]
    };

  }]);

})();
